export default "__VITE_ASSET__DCgI$R7W__"